import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType } from "../CalmBaseScenario";
import Scenario4 from "./Scenario4";

export default class Scenario4Part2 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 1;
	chapterIds = {
		scenario4_2A_s3: 'CALM - Scenario 4 - 2A - Segment 3',
		scenario4_2A_s4a:'CALM - Scenario 4 - 2A - Segment 4A',
		scenario4_3A_s4b:'CALM - Scenario 4 - 3A - Segment 4B',
	}

	constructor(scenario: Scenario4, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario4/calm-scenario4-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario4.parts.level4Part2.id;
	}

	public start() {
		const context = this;
		context.segment1Step1MirandaApproaches();

	}

	private segment1Step1MirandaApproaches() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(this.chapterIds.scenario4_2A_s3, () =>
			context.segment1Step2Dialogue())
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C10-L3-000a',
			[{
				text: 'Go ahead and discharge him. He’s good to go.',
				feedback: 'Discharging a patient involves ensuring certain patient care and needs have been met before the patient can be discharged. Making follow-up appointments, providing wound care instructions and materials, and taking an MRSA nasal swab are just some of the tasks that must be accomplished before a patient can be discharged. All these things, and possibly more, need to happen before the patient can be discharged.',
				scoreType: ScoreType.Worst,
				isCorrect: false // Rank worst
			}, {
				text: 'First take his vital signs. We need to be sure he’s healthy.',
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here				
				context.scenario.evaluateAnswer(selectedOption, () => 
				context.segment2Step1AfterResponse(), 
				context.partIndx);
				
			}
		);
		context.scenario.updateObjective('Select your response to Miranda');
	}

	private segment2Step1AfterResponse() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario4_2A_s4a, () => {
			this.onDone();
		});
		context.scenario.updateObjective('');
	}

	
}